import { Box, Grid } from '@mui/material'
import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import MarketBanner from 'components/Banner/MarketBanner'
import PrizesBanner from 'components/Banner/PrizesBanner'
import PawHeader from 'components/Text/PawHeader'
import Partner from 'components/Footer/Partner'
import CommunityBox from './components/CommunityBox'
import LastetTweet from '../../components/Twitter/LastetTweet'
import OverviewStatusCard from './components/OverviewStatusCard'
import NFTGameBanner from '../../components/Banner/NFTGameBanner'
import EarnBox from './components/EarnBox'

const useStyles = makeStyles((theme) => ({
  pageCover: {
    padding: '16px',
  },
  skyContainer: {
    backgroundColor: theme.palette.primary.main,
  },
  statsContainer: {
    paddingTop: theme.spacing(4),
  },
  jumboText: {
    fontSize: '48px',
    fontWeight: 900,
  },
  connerLeftText: {
    fontSize: '13px',
    position: 'absolute',
    bottom: 20,
    left: 0,
  },
  connerRight: {
    position: 'absolute',
    bottom: 4,
    right: 4,
    width: 88,
  },
  HeadText: {
    fontSize: '24px',
    display: 'block',
    margin: '8px 0',
    fontWeight: 600,
  },
  ValueText: {
    fontSize: '20px',
    display: 'block',
    margin: '0 8px',
    textAlign: 'center',
  },
  farmContainer: {
    paddingTop: theme.spacing(5),
  },
  primaryHeadLine: {
    fontSize: '36px',
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
    '& img': {
      width: '80px',
    },
  },
  gridMain: {
    paddingTop: theme.spacing(3),
    position: 'relative',
    zIndex: 11,
  },
  videoCover: {
    marginTop: theme.spacing(3),
    position: 'relative',
    paddingBottom: '56.25%',
    height: 0,
    overflow: 'hidden',
    maxWidth: '100%',
    '& iframe': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
    '& object': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
    '& embed': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
  },
  [theme.breakpoints.up('sm')]: {
    pageCover: {
      padding: '24px',
    },
  },
}))

const Home: React.FC = () => {
  // const TranslateString = useI18n()
  const classes = useStyles()

  return (
    <>
      <Box className={classes.pageCover}>
        <OverviewStatusCard />
        <Grid container className={classes.gridMain} alignItems="stretch" spacing={4}>
          <Grid item md={6} xs={12}>
            <LastetTweet account="samoyedfinance" />
          </Grid>
          <Grid item md={6} xs={12}>
            <PrizesBanner />
            <MarketBanner />
          </Grid>
          <Grid item xs={12}>
            <PawHeader color="pink" size="36" textColor="black" textSize="36" text="Partners" />
            <Partner />
            <PawHeader color="pink" size="36" textColor="black" textSize="36" text="NFT Games" />
            <NFTGameBanner />
            <PawHeader color="pink" size="36" textColor="black" textSize="36" text="Earn" />
            <EarnBox />
            <PawHeader color="pink" size="36" textColor="black" textSize="36" text="Community" />
            <CommunityBox />
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default Home
